
import airQualityIndex from './svg/airQualityIndex.svg';
import radiation from './svg/radiation.svg';
import so2 from './svg/so2.jpg';
import co from './svg/co.jpg';
import no2 from './svg/no2_v2.png';
import pm25 from './svg/pm2.5_v2.svg';
import pm10 from './svg/pm10_v2.svg';
import o3 from './svg/ozone.svg';
import priPoll from './svg/primaryPollutant.png';

// Convert from inHg to Pascals. 1 inHg = 33.86 pascals
export const PASCAL =  33.86;
/*
  Used in Time Slider: Maps integer values to time on a 6am - 12a slider
*/
export const TIME = {
  1: '06',
  2: '07',
  3: '08',
  4: '09',
  5: '10',
  6: '11',
  7: '12',
  8: '13',
  9: '14',
  10: '15',
  11: '16',
  12: '17',
  13: '18',
  14: '19',
  15: '20',
  16: '21',
  17: '22',
  18: '23',
  19: '00'
};


export const WEATHER_CODES = {
  'freezing_rain_heavy': 'wi-day-sleet-storm',
  'Heavy Freezing Rain': 'wi-day-sleet-storm',
  'freezing_rain': 'wi-day-sleet',
  'Freezing Rain': 'wi-day-sleet',
  'freezing_rain_light': 'wi-day-sleet',
  'Light Freezing Rain': 'wi-day-sleet',
  'freezing_drizzle': 'wi-day-sleet',
  'Freezing Drizzle': 'wi-day-sleet',
  'ice_pellets_heavy': 'wi-day-snow-thunderstorm',
  'Heavy Ice Pellets': 'wi-day-snow-thunderstorm',
  'ice_pellets': 'wi-day-snow',
  'ice_pellets_light': 'wi-day-snow',
  'Light Ice Pellets': 'wi-day-snow',
  'snow_heavy': 'wi-day-snow-thunderstorm',
  'Heavy Snow': 'wi-day-snow-thunderstorm',
  'snow': 'wi-day-snow',
  'Snow': 'wi-day-snow',
  'snow_light': 'wi-day-snow',
  'Light Snow': 'wi-day-snow',
  'flurries': 'wi-day-storm-showers',
  'Flurries': 'wi-day-storm-showers',
  'tstorm': 'wi-day-thunderstorm',
  'Thunderstorm': 'wi-day-thunderstorm',
  'rain_heavy': 'wi-day-rain',
  'Heavy Rain': 'wi-day-rain',
  'rain': 'wi-day-showers',
  'Rain': 'wi-day-showers',
  'rain_light': 'wi-day-sprinkle',
  'Light Rain': 'wi-day-sprinkle',
  'drizzle': 'wi-day-rain-mix',
  'Drizzle': 'wi-day-rain-mix',
  'fog_light': 'wi-fog',
  'Light Fog': 'wi-fog',
  'fog': 'wi-day-fog',
  'Fog': 'wi-day-fog',
  'cloudy': 'wi-cloudy',
  'Cloudy': 'wi-cloudy',
  'mostly_cloudy': 'wi-day-cloudy',
  'Mostly Cloudy': 'wi-day-cloudy',
  'partly_cloudy': 'wi-day-cloudy-high',
  'Partly Cloudy': 'wi-day-cloudy-high',
  'mostly_clear': 'wi-day-haze',
  'Mostly Clear': 'wi-day-haze',
  'clear': 'wi-day-sunny',
  'Clear': 'wi-day-sunny',
  'Light Wind': 'wi-windy'
};

export const SVG = {
  'surface_shortwave_radiation': radiation,
  'epa_aqi': airQualityIndex,
  'pm25': pm25,
  'pm10': pm10,
  'o3': o3,
  'no2': no2,
  'co': co,
  'so2': so2,
  'epa_primary_pollutant': priPoll
}


















/* END */



// WEBPACK FOOTER //
// ./src/weather/constants.js